import React from "react";
import classNames from "classnames";
import { IconArrowDownRight, IconArrowUpRight } from "./icons";
import { formatChangeRate } from "./utils";
import styles from "./index.module.less";

/** 对齐 spikex-ai-web ChangePill subtle */
export default function ChangePill({ doc, subtle = true }) {
  const change = Number(doc?.cr ?? doc?.r ?? 0);
  const isUp = change >= 0;
  const Icon = isUp ? IconArrowUpRight : IconArrowDownRight;

  return (
    <span
      className={classNames(
        styles.changePill,
        subtle && styles.changePillSubtle,
        isUp ? styles.up : styles.down
      )}
    >
      <Icon className={styles.changePillIcon} />
      {formatChangeRate(doc)}
    </span>
  );
}
